import { Buffer } from 'buffer';

export function addPolyfills() {
  window.Buffer = Buffer; // @atlaskit/media-viewer needs this polyfill to work
}
